<template>
  <div v-if="!childCompaniesLoading">
    <v-select
      v-model="childCompany"
      :items="childCompanies"
      :placeholder="$t('navigation.master.placeholder-company')"
      variant="plain"
      hide-details
      density="compact"
      class="custom-select"
      menu-icon="null"
      append-inner-icon="mdi-chevron-down"
      :disabled="!isMasterView"
      :menu-props="{ zIndex: 10001 }"
    >
      <template #item="{ props: itemProps, item }">
        <v-list-item
          v-bind="itemProps"
          :title="generateTitle(item)"
        >
          <v-list-item-subtitle v-if="generateSubtitle(item)">
            {{ generateSubtitle(item) }}
          </v-list-item-subtitle>
        </v-list-item>
      </template>
      <template #selection="{ item }">
        {{ generateTitle(item) }}
      </template>
    </v-select>
  </div>
</template>

<script lang="ts" setup>
import { useQuery } from '@vue/apollo-composable'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import GET_CHILD_COMPANIES from '@/modules/company/queries/ChildCompanies.gql'

const route = useRoute()
const router = useRouter()

const props = defineProps({
  isMasterView: Boolean,
  isMasterDashboard: Boolean,
})

const { result: childCompaniesResult, loading: childCompaniesLoading } = useQuery(
  GET_CHILD_COMPANIES,
  {},
  {
    enabled: props.isMasterView,
  }
)

const childCompanies = computed(() => {
  const companies =
    childCompaniesResult.value?.childCompanies
      ?.filter((company) => company.name)
      .map((company) => {
        const ambassadorName = () => {
          const name = company.ambassador?.firstname || ''
          const lastname = company.ambassador?.lastname || ''
          return name && lastname ? `${name} ${lastname}` : ''
        }
        return {
          title: company.name,
          value: company.id,
          city: company.address?.city,
          ambassador: ambassadorName(),
        }
      }) || []

  companies.unshift({
    title: 'All Companies',
    value: 'all',
  })

  return companies
})

//@ts-ignore
const childCompany = ref<string | null>(route?.params?.id ? route.params.id : 'all')

const generateTitle = (item: { raw: { title?: string; ambassador?: string } }) => {
  const { title = '', ambassador = '' } = item.raw
  return [title, ambassador].filter(Boolean).join(' - ')
}

const generateSubtitle = (item: { raw: { city?: string } }) => {
  const { city = '' } = item.raw
  return city
}
watch(childCompany, (newVal) => {
  if (newVal) {
    router.push({
      name: route.name as string,
      params: {
        ...route.params,
        id: newVal !== 'all' ? String(newVal) : null,
      },
      query: route.query,
    })
  }
})
</script>
<style scoped>
.custom-select {
  height: 40px;
}
:deep(.custom-select .v-field),
:deep(.custom-select .v-field) {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #6e6e6e;
}
:deep(.v-field--disabled) {
  opacity: 1;
}
</style>
